import artifact from '$houdini/artifacts/MyAccountUpdateSessionUser'
import { MutationStore } from '../runtime/stores/mutation'

export class MyAccountUpdateSessionUserStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
